import * as __model from '../model';

export class offerComment {
    offerCommentId: number;
    comment: string;
    offerId: number;
    userId: number;
    rowversion: string;
}